import { render, staticRenderFns } from "./Value.vue?vue&type=template&id=814f2090&scoped=true"
import script from "./Value.vue?vue&type=script&lang=ts"
export * from "./Value.vue?vue&type=script&lang=ts"
import style0 from "./Value.vue?vue&type=style&index=0&id=814f2090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814f2090",
  null
  
)

export default component.exports